import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppContext from 'context/Context';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import Footer from 'components/footer/Footer';
import ProductProvider from 'components/app/e-commerce/ProductProvider';
import CourseProvider from 'components/app/e-learning/CourseProvider';
import { getFathers } from 'data/apiConection.js/dataUsers';

const MainLayout = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null); // Estado para el usuario
  const [loading, setLoading] = useState(true); // Estado para el indicador de carga
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  const {
    config: { isFluid, navbarPosition },
  } = useContext(AppContext);

  // Efecto para manejar el scroll
  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, [hash]);

  // Efecto para manejar la navegación
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Efecto para validar el usuario
  useEffect(() => {
    const fetchUser = async () => {
      const user = await getFathers(); // Supongamos que getUsers es una función asíncrona
      console.table(user);
      if (user) {
        setUser(user); // Guarda el usuario en el estado
      } else {
      user.role === 'father'? 
      navigate('/estados-cuentas'):
      navigate('/login-cuota'); // Redirige al login si no hay usuario
      }
      setLoading(false); // Finaliza la carga
      return user;
    };

    fetchUser();
  }, [navigate]);

  // Muestra un indicador de carga mientras se valida al usuario
  if (loading) {
    return <div>Cargando...</div>; // Puedes personalizar este mensaje o usar un spinner
  }

  return (
    <div  style={{ width: '100%' }} className={isFluid ? 'container-fluid' : 'container'}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical style={{  width: '50%' }} />
      )}
      <ProductProvider>
        <CourseProvider>
        <div style={{  width: '98%' }} className={classNames('content', { 'pb-0': isKanban })}>
            <NavbarTop />
            {/* Renderiza contenido solo si hay un usuario */}
            {user ? <Outlet /> : null}
            {!isKanban && <Footer />}
          </div>
        </CourseProvider>
      </ProductProvider>
    </div>
  );
};

export default MainLayout;

